export default function OrganizationTreeList({ rows, children }) {
  const maxLevel = rows.reduce((maximum, row) => Math.max(maximum, row.level), 1)
  return (
    <div className="platform-mobile-list org-tree-list" role="list" style={{ '--org-tree-max-level': maxLevel }}>
      {children}
    </div>
  )
}
